var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForms({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "9 3.5 29 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4336 11.0009C36.4336 11.3576 36.4731 41.0925 36.2213 41.3448C35.9695 41.5972 35.628 41.7391 35.2718 41.7393H11.6318C11.2756 41.7391 10.9341 41.5972 10.6823 41.3448C10.4305 41.0925 10.2891 40.7503 10.2891 40.3936V6.0343C10.2891 5.67754 10.4305 5.33538 10.6823 5.08303C10.9341 4.83069 11.2756 4.68881 11.6318 4.6886H30.292",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9336 22.0009C25.9336 22.0009 31.7518 22.0009 33.9336 22.0009",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9336 22.0009C12.9336 22.0009 18.7518 22.0009 20.9336 22.0009",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9336 27.0009C25.9336 27.0009 31.7518 27.0009 33.9336 27.0009",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9336 27.0009C12.9336 27.0009 18.7518 27.0009 20.9336 27.0009",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9336 27.0009C25.9336 27.0009 31.7518 27.0009 33.9336 27.0009",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9336 27.0009C12.9336 27.0009 18.7518 27.0009 20.9336 27.0009",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9336 27.0009C25.9336 27.0009 31.7518 27.0009 33.9336 27.0009",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9336 27.0009C12.9336 27.0009 18.7518 27.0009 20.9336 27.0009",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9336 27.0009C12.9336 27.0009 18.7518 27.0009 20.9336 27.0009",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9336 32.0009C25.9336 32.0009 31.7518 32.0009 33.9336 32.0009",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9336 32.0009C12.9336 32.0009 18.7518 32.0009 20.9336 32.0009",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5703 4.97876L36.4854 10.8939",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6094 5.00085V10.9474H36.2451",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms);
export default __webpack_public_path__ + "static/media/Forms.09f285b520c5bab5263e8023444cd99b.svg";
export { ForwardRef as ReactComponent };